import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function ActivityDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const API = process.env.PARCEL_API_URL;

  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true); // 🔥 NEW

  useEffect(() => {
    if (!API) return;

    axios
      .get(`${API}/api/activities`)
      .then((res) => {
        const found = res.data.find((a) => a._id === id);
        setActivity(found);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false)); // 🔥 STOP LOADING
  }, [id, API]);

  // 🔥 SKELETON UI
  if (loading) {
    return (
      <div className="min-h-screen bg-orange-50 px-6 md:px-24 py-16 animate-pulse">

        <div className="mb-6 w-24 h-4 bg-gray-300 rounded"></div>

        <div className="text-center">
          {/* TITLE */}
          <div className="h-8 md:h-10 bg-gray-300 rounded w-1/2 mx-auto mb-8"></div>

          {/* IMAGE */}
          <div className="w-full max-w-3xl h-64 md:h-80 bg-gray-300 rounded-xl mx-auto mb-8"></div>

          {/* DESCRIPTION */}
          <div className="space-y-3 max-w-2xl mx-auto">
            <div className="h-4 bg-gray-300 rounded"></div>
            <div className="h-4 bg-gray-300 rounded w-5/6"></div>
            <div className="h-4 bg-gray-300 rounded w-4/6"></div>
          </div>
        </div>
      </div>
    );
  }

  // 🔥 NO DATA
  if (!activity) {
    return <p className="p-10 text-center">Activity not found</p>;
  }

  return (
    <div className="min-h-screen bg-orange-50 px-6 md:px-24 py-16">

      {/* 🔙 BACK BUTTON */}
      <button
        onClick={() => navigate(-1)}
        className="mb-6 text-orange-500 font-semibold hover:underline"
      >
        ← Back
      </button>

      {/* 🔥 CONTENT */}
      <div className="text-center">

        {/* TITLE */}
        <h1 className="text-3xl md:text-4xl font-bold text-orange-500 mb-8">
          {activity.name}
        </h1>

        {/* IMAGE */}
        {activity.image && (
          <img
            src={activity.image}
            alt={activity.name}
            className="w-full max-w-3xl mx-auto rounded-xl mb-8 shadow-lg"
            onError={(e) => (e.target.style.display = "none")}
          />
        )}

        {/* DESCRIPTION */}
        <p className="text-gray-700 max-w-2xl mx-auto text-lg leading-relaxed">
          {activity.desc}
        </p>

      </div>
    </div>
  );
}